
<template>
  <div class="refund_wrap">
    <div class="title-h2">{{refund_status(detailData.refund_status)}}</div>
    <div class="refund-account">
      <div
        class="item"
        v-if="detailData.refund_status != -1"
      >
        <div class="left">退款余额</div>
        <div class="right">¥{{detailData.refund_price}}</div>
      </div>
      <div class="item">
        <div class="left">退款账户</div>
        <div class="right">{{detailData.refund_identify}}</div>
      </div>
    </div>
    <div class="title-h3">退款流程</div>
    <ul class="refund-ul">
      <li v-for="item in detailData.step">
        <div class="title">{{item.title}}</div>
        <div class="text">{{item.content}}</div>
        <div class="time">{{item.time}}</div>
      </li>
    </ul>
    <div class="title-h3">退款信息</div>
    <div class="info-box">
      <div class="left"><img
          :src="detailData.crop_image"
          alt=""
        ></div>
      <div class="mid">{{detailData.crop_name}}</div>
      <div class="right">
        <p class="p1">¥{{detailData.one_price}}/亩</p>
        <p class="p2">×{{detailData.total_mu}}亩</p>
        <p class="p3">合计：<span>¥{{detailData.total_price}}</span></p>
      </div>
    </div>
    <ul class="info-ul">
      <li>
        <div class="left">退款原因</div>
        <div class="right">{{detailData.refund_reason}}</div>
      </li>
      <li>
        <div class="left">申请时间</div>
        <div class="right">{{detailData.refund_time}}</div>
      </li>
      <li>
        <div class="left">订单编号</div>
        <div class="right">{{detailData.order_sn}}</div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "../../http";
export default {
  name: "refund_detail",
  components: {},
  props: {},
  data() {
    return {
      detailData: ""
    };
  },
  computed: {
    ...mapState(["token"])
  },
  watch: {},
  mounted() {
    this.getData();
  },
  destroyed() {},
  methods: {
    getData() {
      axios
        .fetchPost("/api/order/refund_detail", {
          order_sn: this.$route.query.order_sn,
          token: this.token
        })
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            this.detailData = data.data;
          }
        })
        .catch(error => {
          console.log("error :>> ", error);
        });
    },
    refund_status(status) {
      let text = "";
      switch (status) {
        case 1:
          text = "退款中...";
          break;
        case 2:
          text = "退款成功";
          break;
        case -1:
          text = "退款失败";
          break;
      }
      return text;
    }
  }
};
</script>
<style lang="stylus" scoped>
.refund_wrap
  text-align left
  background #fff
  .title-h2
    height 50px
    line-height 50px
    color #FF9922
    padding-left 12px
  .refund-account
    border-top 1px solid #E5E5E5
    padding 10px 12px
    border-bottom 10px solid #E5E5E5
    & > .item
      display flex
      justify-content space-between
      .left
        font-size 13px
        color rgba(152, 152, 152, 1)
        line-height 22px
      .right
        font-size 13px
        line-height 22px
        color #282828
  .title-h3
    height 40px
    line-height 40px
    padding-left 12px
    color #282828
    border-bottom 1px solid #e5e5e5
    font-size 14px
  .refund-ul
    border-bottom 10px solid #E5E5E5
    li
      padding-left 12px
      padding 10px 12px
      .title
        font-size 15px
        color #282828
      .text
        font-size 13px
        font-family Microsoft YaHei
        font-weight 400
        color rgba(152, 152, 152, 1)
        line-height 22px
        margin-top 5px
      .time
        font-size 13px
        font-family Microsoft YaHei
        font-weight 400
        color rgba(152, 152, 152, 1)
        line-height 22px
  .info-box
    border-bottom 1px solid #e5e5e5
    padding 10px 12px
    display flex
    .left
      width 62px
      height 62px
      margin-right 10px
      & > img
        display block
        width 100%
        height 100%
    .mid
      color #282828
      font-size 14px
      flex 1
    .right
      flex 1
      font-size 12px
      text-align right
      line-height 22px
      .p1
        color rgba(40, 40, 40, 1)
      .p2
        color #999999
      .p3
        color #282828
        & > span
          color #FF9922
          font-size 15px
  .info-ul
    padding 12px
    li
      display flex
      margin-bottom 5px
      .left
        width 76px
        color #666666
        font-size 13px
      .right
        flex 1
        color #282828
        font-size 13px
</style>